import { getAsyncResource } from "../resource/getAsyncResource.js";
export function usePromise(asyncLoader, parameters, options = {}) {
    return getAsyncResource(asyncLoader, parameters, options).use(options);
}
